export default "__VITE_PUBLIC_ASSET__786ea9e0__"